// `sage preset` installed this file automatically.
// Running `sage preset` again could result in automatic deletion of this file.
// Because of this, we do not recommend editing this file.
import 'foundation-sites/js/entries/foundation'
import 'foundation-sites/js/entries/foundation-plugins'

jQuery(document).ready($ => ($(document).foundation()));

// HACK hau da foundation JS exekutatzeko editorea kargatzean,
// bloke berriak gehitzean, etab.
// Consolean warning batzuk botatzen ditu elementuak dagoeneko
// abiaraziak egon daitezkelako, baina ez dute garrantziarik.
// wp.data.subscribe(function () {
//     let select = wp.data.select('core/editor');

//     if (select.hasChangedContent()) {
//         console.log('waddup')
//         jQuery(document).foundation()
//     }
// });



// WEBPACK FOOTER //
// ./scripts/autoload/_foundation.js